export default __webpack_public_path__ + "static/media/Benton-Sans-Bold.d1aa8cc7.otf";